import { createFileRoute } from '@tanstack/react-router';

import { buildFaqPageSchema, buildSeoHead, jsonLdScript, ROUTE_META } from '@src/corelib/seo';
import { DefaultLayout } from '@src/layout';
import { Pricing as PricingPage } from '@src/pages/Pricing';
import { FAQS } from '@src/pages/Pricing/Pricing';

export const Route = createFileRoute('/pricing')({
  head: () => ({
    ...buildSeoHead({ path: '/pricing', ...ROUTE_META['/pricing'] }),
    scripts: [jsonLdScript(buildFaqPageSchema(FAQS))],
  }),
  component: PricingPageWithLayout,
});

function PricingPageWithLayout() {
  return (
    <DefaultLayout>
      <PricingPage />
    </DefaultLayout>
  );
}
